import './style.scss';

/*
import baseStyles from '!!raw!postcss!sass!./style.scss';

let styles = baseStyles;

export const setStyles = (newStyles) => styles = newStyles;
export const getStyles = () => styles;
*/



/** WEBPACK FOOTER **
 ** ./_src/DatePickerModal/feature/style/index.js
 **/